import { createContext, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { showModalAction } from 'Store/modules/app/actions';
import { readOnlySelector, userStageSelector } from 'Store/modules/validations/selectors';
import { useRestartUser } from 'Containers/Validations/hooks';
import Modal from 'Components/Modal';
import { WARNING_MODAL } from 'Constants/modals';
import { defaultValues, ReadOnlyContextType, ReadOnlyProviderProps } from './types';

const ReadonlyContext = createContext<ReadOnlyContextType>(defaultValues);

export const ReadOnlyProvider = ({
  section,
  children,
}: ReadOnlyProviderProps): JSX.Element | null => {
  const readOnly = useSelector(readOnlySelector);
  const userStage = useSelector(userStageSelector);
  const { mutate } = useRestartUser(section);

  const dispatch = useDispatch();
  const onResultAction = (): void => {
    dispatch(
      showModalAction({
        title: 'UserRestart.modal.title',
        content: 'UserRestart.modal.description',
        link: null,
        options: {
          type: WARNING_MODAL,
          action: mutate,
          acceptText: 'ReviewTax.modal.acceptText',
          cancelText: 'ReviewTax.modal.cancelText',
          isAcceptDanger: true,
        },
        Component: Modal,
      })
    );
  };

  const onReadOnly = (): void => onResultAction();

  const values = useMemo(() => ({ onReadOnly, readOnly }), [userStage]);
  return <ReadonlyContext.Provider value={values}>{children}</ReadonlyContext.Provider>;
};

export default ReadonlyContext;
